import Vue  from 'vue';
import Keycloak from 'keycloak-js';

const initOptions = {
  url: process.env.VUE_APP_AUTH_URL,
  realm: process.env.VUE_APP_REALM,
  clientId: process.env.VUE_APP_CLIENT,
  onLoad: 'check-sso'
}

const keycloak = Keycloak(initOptions)

const keycloakPlugin = {
  install: Vue => {
    Vue.$keycloak = keycloak;
  },
};
Plugin.install = Vue => {
  Vue.$keycloak = keycloak;
  Object.defineProperties(Vue.prototype, {
    $keycloak: {
      get() {
        return keycloak;
      },
    },
  });
};

Vue.use(keycloakPlugin);

export default keycloakPlugin;
